export default [
    {
        path: 'mapa-producao',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-mapa-producao' */
            '@/views/exame-laboratorial/mapa-producao/Index'
        ),
        redirect: 'mapa-producao/create',
        children: [
            {
                name: 'exame-laboratorial-mapa-producao-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-mapa-producao' */
                    '@/views/exame-laboratorial/mapa-producao/Form.vue'
                ),
            },
        ],
    }
]